import { Badge, Pill } from '@design-system';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { isSoldOut } from '../../utils/product';
import { getTileStatus } from './utils/status';

type Props = {
  product: Product;
  isPreOrder?: boolean;
  showCollectionBadge?: boolean;
};

const ProductTileBadge: React.FC<Props> = ({
  isPreOrder,
  product,
  showCollectionBadge = false,
}) => {
  const { t } = useTranslation('product');
  const tileStatus = getTileStatus(product, isPreOrder);
  const showBadges =
    (!isSoldOut(product) && tileStatus) || product.productType === 'Collection';
  if (!showBadges) return null;

  return (
    <div className="flex w-full flex-wrap justify-end gap-2">
      {!isSoldOut(product) && tileStatus && (
        <Pill isActive={tileStatus.active} label={t(tileStatus.key)} />
      )}
      {showCollectionBadge && product.productType === 'Collection' && (
        <Badge label={product.editionSize.toString()} />
      )}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default ProductTileBadge;
